<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal" [ngClass]="{'show': showModal}">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="hideModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">
                    {{amenitiesService.amenityInAmenityModal.amenityName}}
                    {{amenitiesService.amenityInAmenityModal.isEvent ? ' (' + amenitiesService.amenityInAmenityModal.event.name + ')' : ''}}
                </h4>
            </div>
            <div class="modal-body">
                <div class="detailed-view-navigation"
                     *ngIf="amenitiesService.amenityInAmenityModal.payments.length || (amenitiesService.amenityInAmenityModal.event?.bookings.length && !authService.userIsResident)">
                    <div class="col-xs-6 col-md-6 no-padding">
                        <div class="button-section"
                             [ngClass]="{'active': activeTab === 'info'}"
                             (click)="changeTab('info');">Info</div>
                    </div>
                    <div class="col-xs-6 col-md-6 no-padding">
                        <div class="button-section"
                             *ngIf="amenitiesService.amenityInAmenityModal.payments.length"
                             [ngClass]="{'active': activeTab === 'payments'}"
                             (click)="changeTab('payments');">Payments</div>
                    </div>
                    <div class="col-xs-6 col-md-6 no-padding">
                        <div class="button-section"
                             *ngIf="amenitiesService.amenityInAmenityModal.event?.bookings.length && !authService.userIsResident"
                             [ngClass]="{'active': activeTab === 'booking'}"
                             (click)="changeTab('booking');">
                            Bookings
                        </div>
                    </div>
                </div>
                <div class="m-t-sm">
                    <amenities-info *ngIf="activeTab === 'info'"></amenities-info>
                    <amenities-payments *ngIf="activeTab === 'payments'"></amenities-payments>
                    <div *ngIf="activeTab === 'booking'">
                        <div class="row booking-row"
                             *ngFor="let booking of amenitiesService.amenityInAmenityModal.event.bookings">
                            <div class="col-md-4 m-b-sm">ID</div>
                            <div class="col-md-8 m-b-sm">{{booking?.bookingNumber || '-'}}</div>
                            <div class="col-md-4 m-b-sm">Unit</div>
                            <div class="col-md-8 m-b-sm">{{booking?.suite?.suiteNumber || '-'}}</div>
                            <div class="col-md-4 m-b-sm">Resident</div>
                            <div class="col-md-8 m-b-sm">{{booking?.resident?.fullName || '-'}}</div>
                            <div class="col-md-4 m-b-sm">Status</div>
                            <div class="col-md-8 m-b-sm">
                                <span *ngIf="booking?.status === 'approved'" class="label label-approved">Approved</span>
                                <span *ngIf="booking?.status === 'pending'" class="label label-pending">Pending</span>
                                <span *ngIf="booking?.status === 'expired'" class="label label-expired">Expired</span>
                                <span *ngIf="booking?.status === 'declined'" class="label label-declined">Declined</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <spinner [spinnerShow]="amenitiesService.spinnerShow ||
                        (amenitiesService.calendarSpinnerShow && amenitiesService.view == 'calendar')"></spinner>
        </div>
    </div>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-view/amenities-view.component.html